import { render, staticRenderFns } from "./CommList.vue?vue&type=template&id=44082b13&"
import script from "./CommList.vue?vue&type=script&lang=js&"
export * from "./CommList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports